import { styled } from "@mui/material"

interface Props {
  size?: "medium" | "large"
}

export const Link = styled("a")<Props>(({ size = "large" }) => ({
    color: "#0055B0",
    fontWeight: "700",
    fontSize: "14px",
    textDecoration: "none",
    lineHeight: "28px",
    gap: "12px",
    display: "flex",
    padding: "10px 16px",
    cursor: "pointer",
    textTransform: "capitalize",
    whiteSpace: "nowrap",

    ...size === "medium" && { padding: "5px 16px" }
  })
)
